// DOM-specific JS should be done here
// see /boilerplate/src/js/browser.js for the import pattern

import select from 'dom-select';
import debounce from 'debounce';

export const InPageNav = (el) => {
  const ui = {
    el,
    body: select('body', document),
    layout: select('.in-page-nav__layout', el),
    details: select('.in-page-nav__details', el),
  };

  const threshold = 834;

  const handleResize = () => {
    if (ui.body.offsetWidth < threshold) {
      ui.details.open = false;
    } else {
      ui.details.open = true;
    }
  }

  const addEvents = () => {
    handleResize();

    window.onresize = debounce(() => {
      handleResize();
    }, 100);
  }

  const init = () => {
    addEvents();
  };

  init();
};

export default InPageNav;
